import {gsap, Draggable, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {BaseGameMNS2} from "../base/BaseGameMNS2";
import {BioMeterUI} from "./BioMeterUI";
import {DRAGGABLE_SCENE_POSITIONING, DraggableScene} from "../etoiles/DraggableScene";
import {BioScene} from "./BioScene";
import {CausalityEffects} from "./CausalityEffects";
import {SecondaryCausalityEffects} from "./SecondaryCausalityEffects";

// Constructor
export class BiodiversiteApp extends BaseGameMNS2 {

  constructor() {
    super(`data/biodiversite.json`);
    gsap.registerPlugin(Draggable)
    gsap.registerPlugin(InertiaPlugin)

    this.shownProgressEffects = {
      halfway_low_result_tooltip: false,
      causality_effects: false,
    };

    this.bioScenes = {
      level1: null,
      level2: null,
      level3: null,
    }

    this.causalityEffects = {
      level1: null,
      level2: null,
      level3: null,
    }

    this.secondaryCausalityEffects = {
      level1: null,
      level2: null,
      level3: null,
    }

  }

  loadData(filename = null) {
    if (filename !== null) return super.loadData(filename);

    // Group order
    const groupOrder = {vegetal: 1, living: 2, human: 3};

    // Merge tools from previous levels to avoid too large json (DRY)
    return super.loadData(filename).then(() => {
      let mergedTools = [];
      for (const level of ["level1", "level2", "level3"]) {
        mergedTools = [...mergedTools, ...this.data.content["bioscene_" + level].tools]
        mergedTools.sort((a, b) => groupOrder[a.group] - groupOrder[b.group]);
        this.data.content["bioscene_" + level].tools = [...mergedTools];
      }
    });
  }

  // To be overridden in child games
  initGame() {

    // TODO Complete message handling when final screen will be integrated
    this.seveCtaScreenID = 3;
    this.seveCommunication.on("buttonPressed", (e) => this.onButtonPressed(e));

    this.biometer = new BioMeterUI("#biometer-ui");

    // Init bioscenes
    for (const level of ["level1", "level2", "level3"]) {
      this.bioScenes[level] = new BioScene({
        selector: "#bioscene-" + level.toUpperCase(),
        toolboxSelector: "#biotoolbox-" + level.toUpperCase(),
        data: this.data.content["bioscene_" + level],
        biometer: this.biometer,
        biodiversityCallback: this.updateBioMeter.bind(this),
        tooltipCallback: this.showScreenTopTooltip.bind(this),
      });
      this.causalityEffects[level] = new CausalityEffects("#causality-effects-" + level.toUpperCase(), level)
      this.secondaryCausalityEffects[level] = new SecondaryCausalityEffects("#secondary-causality-effects-" + level.toUpperCase(), level)
    }

    super.initGame();
    // TODO: For debugging
    // this.level = 'level3'
    // super.initGame(2);
  }

  // onSelectAnswer(optionValue) {
  //   console.log("onSelectAnswer", optionValue)
  // }
  //
  // onQuizComplete(finalValue) {
  //   console.log("onQuizComplete", finalValue)
  //
  //   // TODO set content with final value
  //   this.goToScreen(5)
  // }

  // To be overridden in child games
  initScreen(screenId) {
    super.lottieAutoPlaybackForScreen(screenId);

    const screenIdNoLevel = parseInt(screenId.toString().replace("-" + this.level, ""));
    console.log("initScreen ids:", {screenIdNoLevel: screenIdNoLevel, screenId: screenId});

    if (screenId === 1) {
      this.seveCommunication.sendMessage(0);

    } else if (screenId === 2) {
      this.seveCommunication.sendMessage(1);

      // Show the appropriate content in to tooltip
      $("#screen-2 .top-tooltip .tooltip-item").each((i, element) => {
        $(element).toggle(($(element).data("item-id") === this.level))
      })

      // Make sure that the top tooltips starts at the correct position, dependent on the level
      const $topTooltip = $("#screen-2").find(".top-tooltip .wrapper")
      gsap.set($topTooltip, {y: -$topTooltip.find(".inner").outerHeight()});

      // Show the appropriate handcoach
      $("#screen-2 .handcoach").each((i, element) => {
        $(element).toggleClass("excluded", ($(element).data("level") !== this.level))
      })

      // Select bioscene for level
      this.selectBioscene(this.level);

    } else if (screenId === 3) {
      this.seveCommunication.sendMessage(3);
      this.audio.play("audio/MNS2_Communs_SFX/MNS2_ME_SFXpartage.mp3", 1, true)
      this.seveVideoPlayback("cta")
      // Auto quit app
      this.currentTimeline = gsap.timeline();
      this.currentTimeline.add(() => this.reset(), 14)
    }

    // Changle language switcher position
    this.setAdditionalToolsVisibility((screenId !== 1 && screenId !== this.seveCtaScreenID), (screenId !== 1 && screenId !== this.seveCtaScreenID));

  }

  selectBioscene(level) {
    $(".bioscene").each((i, n) => {
      const elLevel = $(n).data("level");
      if ($(n).attr("id") === "bioscene-" + level.toUpperCase()) {
        // Is the bioscene we are looking for
        $(n).show();
        if (this.bioScenes[level]) this.bioScenes[level].enable();
      } else {
        // Reject this bioscene
        $(n).hide()
        if (this.bioScenes[level]) this.bioScenes[level].disable();
      }
    })
  }

  updateBioMeter(score, toolName = null, dropZone = null) {
    this.biometer.to(score.result);

    // Show progress related popups and effects
    if (score.completed > 0.5 && score.result < 0.5 && !this.shownProgressEffects["halfway_low_result_tooltip"]) {
      app.toggleTooltip(true, this.level + "_halfway_low_result_tooltip")
      this.shownProgressEffects["halfway_low_result_tooltip"] = true;
    } else if (score.result >= 0.6 && score.completed >= 1 && !this.shownProgressEffects["causality_effects"]) {
      // Keep threshold above 0.5 to avoid completion with no diversity at all
      this.causalityEffects[this.level].play();
      this.shownProgressEffects["causality_effects"] = true;
    }

    // À partir de 50%, lorsqu'on met quelque chose de positive (et pas le gazon) on déclenche une animation secondaire.
    if (score.result > 0.50 && this.bioScenes[this.level].getPositiveTools().includes(toolName)) {
      this.secondaryCausalityEffects[this.level].triggerAvailableEffect(toolName, dropZone);
    }
  }

  updateSeveVideosSrc(language) {
    super.updateSeveVideosSrc(language,
      "videos/seve_A/ZONE5_ME_MNS2_INTNUM_ENVOIE_SEVE_{{LANG}}.mp4",
      "videos/seve_B/ZONE5_ME_MNS2_VID_SEVE_ENVOYE_{{LANG}}.mp4"
    );
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {
    // TODO: Reset things here

    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);

    const resetCallback = () => {
      // Things that reset after goToScreen
      this.seveVideoPlayback("none")

      // Close all tooltips
      this.toggleTooltip(false)

      // Reset biometer
      this.biometer.to(0, 0)

      // Tooltips memory reset
      this.shownProgressEffects = {
        halfway_low_result_tooltip: false,
        causality_effects: false,
      };

      // Reset bioscenes
      Object.keys(this.bioScenes).forEach((key) => {
        if (this.bioScenes[key]) {
          this.bioScenes[key].reset();
          this.bioScenes[key].disable();
        }
      })

      // Reset causality effects
      Object.keys(this.causalityEffects).forEach((key) => {
        if (this.causalityEffects[key]) {
          this.causalityEffects[key].reset();
        }
      })

      // Reset secondary causality effects
      Object.keys(this.secondaryCausalityEffects).forEach((key) => {
        if (this.secondaryCausalityEffects[key]) {
          this.secondaryCausalityEffects[key].reset();
        }
      })
    }

    // Super
    return super.reset(screenId, resetCallback);

  }

}
